// actions/noticeActions.js
import createApi from "../utils/apiClient";
const api = createApi();

export const getNotices = (params) => async (dispatch) => {
  try {
    dispatch({ type: "NOTICE_REQUEST" });
    const { data } = await api.get("/notices", { params });
    dispatch({ type: "GET_NOTICES_SUCCESS", payload: data.notices });
  } catch (err) {
    dispatch({ type: "NOTICE_FAIL", payload: err.response?.data?.message });
  }
};

export const getUnreadCount = () => async (dispatch) => {
  try {
    const { data } = await api.get("/notices/unread-count");
    dispatch({ type: "NOTICE_UNREAD_COUNT", payload: data.count });
  } catch (err) {}
};

export const createNotice = (noticeData) => async (dispatch) => {
  try {
    dispatch({ type: "NOTICE_REQUEST" });
    const { data } = await api.post("/notices", noticeData);
    dispatch({ type: "CREATE_NOTICE_SUCCESS", payload: data.notice });
    // Refresh notices after creating
    dispatch(getNotices());
  } catch (err) {
    dispatch({ type: "NOTICE_FAIL", payload: err.response?.data?.message });
    throw err;
  }
};

export const toggleNotice = (noticeId) => async (dispatch) => {
  try {
    const { data } = await api.patch(`/notices/${noticeId}/toggle`);
    dispatch({ type: "TOGGLE_NOTICE_SUCCESS", payload: data.notice });
  } catch (err) {
    dispatch({ type: "NOTICE_FAIL", payload: err.response?.data?.message });
    throw err;
  }
};

export const deleteNotice = (noticeId) => async (dispatch) => {
  try {
    await api.delete(`/notices/${noticeId}`);
    dispatch({ type: "DELETE_NOTICE_SUCCESS", payload: noticeId });
  } catch (err) {
    dispatch({ type: "NOTICE_FAIL", payload: err.response?.data?.message });
    throw err;
  }
};
